import '../../assets/css/style.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import React from 'react';

import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { theme } from '../../components/layout/Style';
import HeaderWebPage from './HeaderWebPage';
import BackToTop from '../../components/templates/BackToTop';
import FooterWebPage from './FooterWebPage';
import { INSTITUTIONAL_HEADER_MENU_ITEMS } from '../shared/headerMenus';

const PoliticasDePrivacidade = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <div className="politicas-content">
      <HeaderWebPage
        menuItems={INSTITUTIONAL_HEADER_MENU_ITEMS}
      />

      <section id="politicas">
        <div className="politicas-title-grid">
          <h1>Políticas de Privacidade</h1>
        </div>

        <div className="politicas-grid">
          <div className="politica">
            <p>Esta Política de Privacidade tem por finalidade estabelecer, de forma clara e transparente, as regras sobre o tratamento de dados pessoais dos usuários e lojistas que utilizam o aplicativo <strong>PASSARELA 44</strong>, em conformidade com a Lei nº 13.709/2018 – Lei Geral de Proteção de Dados Pessoais (LGPD), bem como demais normas aplicáveis à proteção da privacidade e dos dados pessoais no ordenamento jurídico brasileiro.</p>
          </div>
        </div>

        <div className="politicas-grid">
          <div className="politica">
            <h2>Controlador e Responsável pelo Tratamento</h2>
            <p>O controlador dos dados pessoais é a empresa <strong>CREATIVE IT LTDA</strong>, inscrita no CNPJ sob nº 64.436.153/0001-69, com sede em Goiânia, Goiás, responsável por determinar as finalidades e os meios de tratamento dos dados pessoais coletados por meio do aplicativo.</p>
          </div>
        </div>

        <div className="politicas-grid">
          <div className="politica">
            <h2>Dados Pessoais Coletados e Finalidade do Tratamento</h2>
            <p>Em atendimento ao princípio da finalidade previsto no artigo 6º, inciso I, da LGPD, os dados pessoais são coletados com propósitos legítimos, específicos e explícitos, sendo vedado o tratamento posterior de forma incompatível com tais finalidades.</p>
            <p>Para os usuários consumidores, são coletados dados como nome completo, CPF, endereço de entrega, e-mail, número de telefone e dados de pagamento, com o objetivo de viabilizar a identificação, autenticação, realização de compras, entrega de produtos e comunicação direta com o titular.</p>
            <p>Para os lojistas anunciantes, são coletados dados como nome ou razão social, CNPJ, endereço comercial, e-mail, telefone e dados bancários, com a finalidade de permitir o cadastro na plataforma, a divulgação de produtos, a gestão de vendas e o repasse de valores decorrentes das transações comerciais.</p>
            <p>Adicionalmente, são coletados dados de navegação, como endereço IP, geolocalização (mediante consentimento), histórico de buscas e interações, bem como cookies e identificadores de dispositivo, com o intuito de aprimorar a experiência do usuário, garantir a segurança da plataforma e realizar análises estatísticas.</p>
          </div>
        </div>

        <div className="politicas-grid">
          <div className="politica">
            <h2>Base Legal para o Tratamento</h2>
            <p>O tratamento dos dados pessoais se fundamenta nas hipóteses legais previstas no artigo 7º da LGPD, especialmente:</p>
            <ul>
              <li>Consentimento do titular (art. 7º, inciso I), quando aplicável, como no caso da coleta de dados de geolocalização;</li>
              <li>Cumprimento de obrigação legal ou regulatória (art. 7º, inciso II), como a emissão de notas fiscais e obrigações tributárias;</li>
              <li>Execução de contrato ou de procedimentos preliminares relacionados ao contrato (art. 7º, inciso V), como a realização de compras e entregas;</li>
              <li>Legítimo interesse do controlador (art. 7º, inciso IX), desde que respeitados os direitos e liberdades fundamentais do titular, como na prevenção à fraude e na melhoria da segurança da plataforma.</li>
            </ul>
          </div>
        </div>

        <div className="politicas-grid">
          <div className="politica">
            <h2>Compartilhamento de Dados Pessoais</h2>
            <p>Os dados pessoais poderão ser compartilhados com terceiros estritamente necessários à execução das finalidades descritas, tais como intermediadores de pagamento, empresas de logística, prestadores de serviços de tecnologia e autoridades públicas, quando exigido por lei ou ordem judicial.</p>
            <p>O compartilhamento será realizado com observância dos princípios da necessidade, adequação e segurança, conforme disposto nos artigos 6º e 46 da LGPD.</p>
          </div>
        </div>

        <div className="politicas-grid">
          <div className="politica">
            <h2>Armazenamento e Segurança dos Dados</h2>
            <p>Os dados pessoais são armazenados em servidores seguros, com aplicação de medidas técnicas e administrativas aptas a proteger os dados contra acessos não autorizados, destruição, perda, alteração ou qualquer forma de tratamento inadequado ou ilícito, conforme previsto no artigo 46 da LGPD.</p>
            <p>A retenção dos dados será realizada pelo período necessário ao cumprimento das finalidades do tratamento, respeitando os prazos legais e regulatórios aplicáveis, ou até que o titular solicite sua exclusão, nos termos do artigo 15 da LGPD.</p>
          </div>
        </div>

        <div className="politicas-grid">
          <div className="politica">
            <h2>Direitos dos Titulares</h2>
            <p>Nos termos do artigo 18 da LGPD, os titulares dos dados pessoais têm direito a obter, mediante requisição expressa, a qualquer momento:</p>
            <ul>
              <li>Confirmação da existência de tratamento;</li>
              <li>Acesso aos dados;</li>
              <li>Correção de dados incompletos, inexatos ou desatualizados;</li>
              <li>Anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com a LGPD;</li>
              <li>Portabilidade dos dados a outro fornecedor de serviço ou produto;</li>
              <li>Eliminação dos dados pessoais tratados com base no consentimento;</li>
              <li>Informação sobre compartilhamento de dados;</li>
              <li>Revogação do consentimento.</li>
            </ul>
            <p>As solicitações deverão ser encaminhadas ao Encarregado de Proteção de Dados (DPO) pelo e-mail: aplicativopassarela44@gmail.com.</p>
          </div>
        </div>

        <div className="politicas-grid">
          <div className="politica">
            <h2>Alterações na Política de Privacidade</h2>
            <p>Esta Política poderá ser modificada a qualquer tempo, visando sua constante atualização e aprimoramento. Alterações relevantes serão comunicadas aos usuários por meio de notificações no aplicativo ou por e-mail, conforme previsto no artigo 9º, §2º, da LGPD.</p>
          </div>
        </div>

        <div className="politicas-grid">
          <div className="politica">
            <h2>Foro e Legislação Aplicável</h2>
            <p>Esta Política será regida e interpretada conforme as leis da República Federativa do Brasil. Fica eleito o foro da comarca de Goiânia, no estado de Goiás, com renúncia a qualquer outro, por mais privilegiado que seja, para dirimir quaisquer controvérsias oriundas deste documento.</p>
            <br />
            <br />
            <br />
            <p>Última atualização: 21/01/2026</p>
          </div>
        </div>
      </section>

      <FooterWebPage />

    </div>
    <BackToTop />
  </ThemeProvider>
)

export default PoliticasDePrivacidade;